<template>

  <BonusTable />

</template>

<script>
import BonusTable from '../components/pratiche/TableBonus.vue'

export default {
  pageName: 'Massive',
  components: {
    BonusTable

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
